// extracted by mini-css-extract-plugin
export default {"wrapper":"VerifyYourEmail_wrapper__k+mmG","infoContainer":"VerifyYourEmail_infoContainer__8NCA6","img":"VerifyYourEmail_img__WcXA8"};